// extracted by mini-css-extract-plugin
export default {"container":"TableCellEditor-module__container--v5rNl","editor":"TableCellEditor-module__editor--Xi-eH"};